var _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_398)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial_18_398)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_398)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 101,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3145 0.158813H-0.685547V100.159H99.3145V0.158813Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8869 28.8026L56.5479 32.126",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9516 30.5838L54.4844 30.3431",
    stroke: "#FF7206",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.077 31.8666C54.7051 31.9822 55.1489 32.4432 55.0661 32.8963C54.9833 33.351 54.4051 33.626 53.777 33.5104C53.1489 33.3963 52.7067 32.9354 52.7895 32.4807C52.8723 32.0275 53.4489 31.7525 54.077 31.8666Z",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2656 34.4182C50.2656 34.4182 50.3781 33.6276 50.8203 33.3448C51.4125 32.9682 52.1594 33.6417 52.9375 34.4729",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9688 33.1025L51.3578 35.526",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3963 37.0964L46.1494 34.8151C46.1494 34.8151 47.1604 34.1167 47.6713 33.9901C48.4494 33.7964 49.1666 34.4651 48.9213 35.0885C48.676 35.7104 47.4447 36.1307 47.4447 36.1307",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0426 35.7463C45.1643 35.7463 45.2629 35.6477 45.2629 35.526C45.2629 35.4043 45.1643 35.3057 45.0426 35.3057C44.9209 35.3057 44.8223 35.4043 44.8223 35.526C44.8223 35.6477 44.9209 35.7463 45.0426 35.7463Z",
    fill: "#FF7206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6582 36.2213L47.1316 37.7604",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0191 36.3432C43.7081 36.3307 42.5488 36.4994 42.5941 37.2447C42.6394 37.99 43.6644 37.9275 44.0831 37.7666C44.5019 37.6041 45.5988 37.3025 45.7956 37.94C46.0206 38.6619 44.7238 39.2025 44.1097 39.176",
    stroke: "#FF7206",
    strokeWidth: 0.388889,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1625 64.1401C56.1625 64.1401 68.8156 60.9198 71.5125 60.5198C74.2109 60.1214 75.5719 63.5526 73.5 64.6901C71.4281 65.8292 56.25 73.5495 54.9234 74.2526C53.6609 74.9229 51.5438 75.6948 48.75 74.2792C45.3922 72.5776 34.4266 68.2823 33.2984 67.9198C32.2031 67.5682 30.0844 67.3932 28.9922 67.5714C27.9984 67.7323 24.125 68.3604 24.125 68.3604V53.2635",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.125 53.2635C24.125 53.2635 32.0203 50.376 37.0891 52.301C39.5078 53.2213 45.6391 56.8479 49.3156 59.2041C52.9922 61.5604 56.8625 63.8791 55.7172 65.8916C54.2594 68.4479 46.8594 64.5932 42.2469 63.5994",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3748 35.1604L35.0185 39.6729L45.1732 51.0917",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3854 32.751L66.765 37.2869L45.1744 51.0916L44.9385 46.6838",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3748 35.1604L44.9373 46.6838L67.3841 32.751L56.4248 22.8229L34.3748 35.1604Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.777778,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_398",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2591 49.7409) rotate(-64.006) scale(69.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862101,
    stopColor: "#EFFBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(-0.688477 0.158813)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.ebe0e257cb02ac33266a1580a7c03d1a.svg";
export { ForwardRef as ReactComponent };